import { render, staticRenderFns } from "./study-engagement.vue?vue&type=template&id=38ce85eb&"
import script from "./study-engagement.vue?vue&type=script&lang=js&"
export * from "./study-engagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "study-engagement.vue"
export default component.exports